import React, { useState, useEffect } from "react"
import moment from "moment"
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import Select from "react-select"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import ConfirmPopup from "components/ConfirmPopup"
import PageLoader from "components/Common/PageLoader"
import TagInput from "components/TagInput"
import { addBazaarInterest } from "../../../redux/actions/pvs"
import { ADD_BAZAAR_INTEREST_RESET } from "../../../redux/types/pvs"
import { getDashboardDataRequest } from "../../../redux/actions/auth"
import { getProductList } from "../../../redux/actions/user"

const stateOptions = [
  {
    options: [
      { label: "Andaman and Nicobar Islands", value: 4023 },
      { label: "Andhra Pradesh", value: 4017 },
      { label: "Arunachal Pradesh", value: 4024 },
      { label: "Assam", value: 4027 },
      { label: "Bihar", value: 4037 },
      { label: "Chandigarh", value: 4031 },
      { label: "Chhattisgarh", value: 4040 },
      { label: "Dadra and Nagar Haveli and Daman and Diu", value: 4033 },
      { label: "Delhi", value: 4021 },
      { label: "Goa", value: 4009 },
      { label: "Gujarat", value: 4030 },
      { label: "Haryana", value: 4007 },
      { label: "Himachal Pradesh", value: 4020 },
      { label: "Jammu and Kashmir", value: 4029 },
      { label: "Jharkhand", value: 4025 },
      { label: "Karnataka", value: 4026 },
      { label: "Kerala", value: 4028 },
      { label: "Ladakh", value: 4852 },
      { label: "Lakshadweep", value: 4019 },
      { label: "Madhya Pradesh", value: 4039 },
      { label: "Maharashtra", value: 4008 },
      { label: "Manipur", value: 4010 },
      { label: "Meghalaya", value: 4006 },
      { label: "Mizoram", value: 4036 },
      { label: "Nagaland", value: 4018 },
      { label: "Odisha", value: 4013 },
      { label: "Puducherry", value: 4011 },
      { label: "Punjab", value: 4015 },
      { label: "Rajasthan", value: 4014 },
      { label: "Sikkim", value: 4034 },
      { label: "Tamil Nadu", value: 4035 },
      { label: "Telangana", value: 4012 },
      { label: "Tripura", value: 4038 },
      { label: "Uttar Pradesh", value: 4022 },
      { label: "Uttarakhand", value: 4016 },
      { label: "West Bengal", value: 4853 },
    ],
  },
]

const BazaarInterestForm = () => {
  const [pvsOptions, setPvsOptions] = useState([])
  const [productOptions, setProductOptions] = useState([])
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)
  const [selectedBazaar, setSelectedBazaar] = useState(null)
  const [selectedPvsCard, setSelectedPvsCard] = useState(null)
  const [formFilled, setFormFilled] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const user = useSelector(state => state.auth.user)
  const pvs_cards = useSelector(state => state.auth.pvs_cards)
  const bazaars = useSelector(state => state.auth.dashboardData.active_bazaars)
  const products = useSelector(state => state.user.products)
  const addBazaarInterestScreen = useSelector(
    state => state.screens.pvs.addBazaarInterest
  )

  const radioOptions = {
    participated: [
      "Yes",
      "No, I am participating for the first time in PULA Bazaar",
    ],
    comingOn: [
      "Yes",
      "None at all",
      "Someone else booking their stall will book for me",
      "Will book online later if stalls available",
    ],
    attendees: [
      "0 as someone else is doing my booking who is already there to book stall for them or will book online later if available",
      "1",
      "2",
      "3",
    ],
  }

  const validation = useFormik({
    initialValues: {
      fullName: user ? `${user.first_name} ${user.last_name}`.trim() : "",
      contactNumber: user ? user.mobile_no || "" : "",
      pvsCard: null,
      participated: "",
      season: "",
      comingOn: "",
      attendees: "",
      products: [],
      otherProducts: [],
      firstName: "",
      lastName: "",
      companyName: "",
      address: "",
      city: "Pune",
      state: stateOptions[0].options[20],
      pincode: "",
      gstNumber: "",
      email: "",
      mobileNo: "",
    },
    validationSchema: Yup.object({
      fullName: Yup.string().required("Full name is required"),
      contactNumber: Yup.string()
        .matches(/^[0-9]{10}$/, "Contact number must be 10 digits")
        .required("Contact number is required"),
      pvsCard: Yup.object().required("Please select your PVS card"),
      participated: Yup.string().required("Please select one option"),
      season: Yup.string().required("Please select one option"),
      comingOn: Yup.string().required("Please select one option"),
      attendees: Yup.string().required("Please select one option"),
      firstName: Yup.string().required("Required"),
      lastName: Yup.string().required("Required"),
      companyName: Yup.string().required("Required"),
      address: Yup.string().required("Required"),
      city: Yup.string().required("Required"),
      state: Yup.object().required("Required").nullable(),
      pincode: Yup.string().required("Required"),
      email: Yup.string()
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Invalid email")
        .required("Required"),
      mobileNo: Yup.string()
        .matches(
          /^[6-9]\d{9}$/,
          "Invalid Mobile Number (should be 10 digits starting with 6-9)"
        )
        .required("Required"),
    }),
    onSubmit: values => {
      const requestBody = {
        combine_group_id:
          selectedBazaar?.combine_group_id || bazaars[0].combine_group_id,
        full_name: values.fullName,
        contact_number: values.contactNumber,
        pvs_card_number: values.pvsCard.value,
        participated_earlier: values.participated,
        bazaar_season_interest: values.season,
        booking_visit_status: values.comingOn,
        people_count_for_booking: values.attendees,
        billing_data: [
          {
            pvs_entry_id: values.pvsCard.pvs_entry_id,
            products: values.products.map(p => p.value).join(","),
            other_products: values.otherProducts.join(", "),
            billing: {
              customer_type: "business",
              first_name: values.firstName,
              last_name: values.lastName,
              email_id: values.email,
              mobile_no: values.mobileNo,
              gst_number: values.gstNumber,
              company_name: values.companyName,
              address: values.address,
              city: values.city,
              state: values.state?.label,
              pincode: values.pincode,
            },
          },
        ],
      }
      dispatch(addBazaarInterest(requestBody))
    },
  })

  useEffect(() => {
    dispatch(getProductList({ offset: 1 }))
    dispatch(getDashboardDataRequest())
    console.log("pvs_cards..", pvs_cards);
    
    if (pvs_cards && pvs_cards.length === 0) {
      setIsConfirmOpen(true)
    }
  }, [])

  useEffect(() => {
    if (
      bazaars &&
      bazaars.length > 0 &&
      bazaars[0].has_filled_interest_form === 1
    ) {
      setFormFilled(true)
    } 
    // else {
      // dispatch(getDashboardDataRequest())
    // }
  }, [bazaars])

  useEffect(() => {
    if (pvs_cards && pvs_cards.length > 0) {
      let tempOptions = pvs_cards.map(card => ({
        ...card,
        label: card.token_code,
        value: card.token_code,
      }))
      setPvsOptions(tempOptions)
      const defaultCard = tempOptions[0]
      validation.setFieldValue("pvsCard", defaultCard)
      setSelectedPvsCard(defaultCard)
    } 
    // else {
    //   if (!addBazaarInterestScreen.success) setIsConfirmOpen(true)
    // }
  }, [pvs_cards])

  useEffect(() => {
    if (addBazaarInterestScreen.success) {
      toast.success(addBazaarInterestScreen.message)
      dispatch({ type: ADD_BAZAAR_INTEREST_RESET })
      setFormFilled(true)
      // navigate("/home")
    }
    if (addBazaarInterestScreen.error) {
      toast.error(addBazaarInterestScreen.message)
      dispatch({ type: ADD_BAZAAR_INTEREST_RESET })
    }
  }, [addBazaarInterestScreen])

  useEffect(() => {
    if (products) {
      setProductOptions(
        products.map(option => ({
          label: option.product_label,
          value: option.product_id,
          encId: option.enc_product_id,
        }))
      )
    }
  }, [products])

  useEffect(() => {
    if (selectedPvsCard && selectedPvsCard.billing) {
      validation.setFieldValue(
        "firstName",
        selectedPvsCard.billing.first_name || ""
      )
      validation.setFieldValue(
        "lastName",
        selectedPvsCard.billing.last_name || ""
      )
      validation.setFieldValue(
        "companyName",
        selectedPvsCard.billing.company_name || ""
      )
      validation.setFieldValue("address", selectedPvsCard.billing.address || "")
      validation.setFieldValue("city", selectedPvsCard.billing.city || "Pune")
      validation.setFieldValue(
        "state",
        selectedPvsCard.billing.state
          ? stateOptions[0].options.find(
              val => val.label === selectedPvsCard.billing.state
            ) || stateOptions[0].options[20]
          : stateOptions[0].options[20]
      )
      validation.setFieldValue("pincode", selectedPvsCard.billing.pincode || "")
      validation.setFieldValue(
        "gstNumber",
        selectedPvsCard.billing.gst_number || ""
      )
      validation.setFieldValue("email", selectedPvsCard.billing.email_id || "")
      validation.setFieldValue(
        "mobileNo",
        selectedPvsCard.billing.mobile_no || ""
      )
    }
    if (
      selectedPvsCard &&
      selectedPvsCard.products &&
      productOptions.length > 0
    ) {
      const selectedProducts = selectedPvsCard.products
        .split(",")
        .reduce((acc, id) => {
          const found = productOptions.find(val => val.value === Number(id))
          if (found) acc.push(found)
          return acc
        }, [])
      validation.setFieldValue("products", selectedProducts)
    }
  }, [selectedPvsCard, productOptions])

  document.title = "PULA Bazaar Booking Form | PULA"

  return (
    <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div
        className="container-fluid"
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <div className="newaward-maincontainer pt-4">
          <Row className="justify-content-center">
            <Col xs={12} sm={11} md={10} lg={8}>
              <div className="form-section p-4 p-md-5">
                <h4 className="nom-title mb-2" style={{ fontSize: "27px" }}>
                  Interest Form
                </h4>

                {formFilled ? (
                // {false ? (
                  <div
                    className="py-5 text-center"
                    style={{ maxWidth: 520, margin: "0 auto" }}
                  >
                    <div style={{ fontSize: "3.5rem", lineHeight: 1 }}>🎉</div>
                    <h4
                      className="mt-4 mb-2"
                      style={{ color: "#1a6e3c", fontWeight: 700 }}
                    >
                      Thank You for Your Interest in Our Upcoming Bazaar!
                    </h4>
                    <p className="text-muted mb-3" style={{ fontSize: "1rem" }}>
                      We&apos;re thrilled to have you on board. Your response
                      has been recorded.
                    </p>
                  </div>
                ) : (
                  <>
                    <p className="text-muted mb-4">
                      Please fill in the details below. Fields marked with * are
                      required.
                    </p>

                    <Form
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="fullName">
                          Full Name <span className="text-danger">*</span>
                        </Label>
                        <Input
                          id="fullName"
                          name="fullName"
                          type="text"
                          value={validation.values.fullName}
                          onChange={validation.handleChange}
                          invalid={
                            validation.touched.fullName &&
                            Boolean(validation.errors.fullName)
                          }
                        />
                        {validation.touched.fullName &&
                          validation.errors.fullName && (
                            <FormFeedback>
                              {validation.errors.fullName}
                            </FormFeedback>
                          )}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label" htmlFor="contactNumber">
                          Contact Number <span className="text-danger">*</span>
                        </Label>
                        <Input
                          id="contactNumber"
                          name="contactNumber"
                          type="text"
                          value={validation.values.contactNumber}
                          onChange={validation.handleChange}
                          invalid={
                            validation.touched.contactNumber &&
                            Boolean(validation.errors.contactNumber)
                          }
                        />
                        {validation.touched.contactNumber &&
                          validation.errors.contactNumber && (
                            <FormFeedback>
                              {validation.errors.contactNumber}
                            </FormFeedback>
                          )}
                      </div>

                      <div className="mb-4">
                        <Label className="form-label d-block">
                          Have you participated with our exhibition earlier?{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        {radioOptions.participated.map(option => (
                          <div className="form-check mb-2" key={option}>
                            <Input
                              id={`participated-${option}`}
                              name="participated"
                              type="radio"
                              className="form-check-input"
                              value={option}
                              checked={
                                validation.values.participated === option
                              }
                              onChange={validation.handleChange}
                            />
                            <Label
                              className="form-check-label"
                              htmlFor={`participated-${option}`}
                            >
                              {option}
                            </Label>
                          </div>
                        ))}
                        {validation.touched.participated &&
                          validation.errors.participated && (
                            <div className="text-danger small">
                              {validation.errors.participated}
                            </div>
                          )}
                      </div>

                      <div className="mb-4">
                        <Label className="form-label d-block">
                          Interested to book for which Season of PULA Bazaar?{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        {bazaars &&
                          bazaars.length > 0 &&
                          bazaars.map(option => (
                            <div
                              className="form-check mb-2"
                              key={option.bazaar_id}
                            >
                              <Input
                                id={`season-${option.bazaar_id}`}
                                name="season"
                                type="radio"
                                className="form-check-input"
                                checked={
                                  validation.values.season ===
                                  option.bazaar_name
                                }
                                onChange={() => {
                                  validation.setFieldValue(
                                    "season",
                                    option.bazaar_name
                                  )
                                  setSelectedBazaar(option)
                                }}
                              />
                              <Label
                                className="form-check-label"
                                htmlFor={`season-${option.bazaar_id}`}
                              >
                                {option.bazaar_name}
                              </Label>
                            </div>
                          ))}
                        <div className="form-check mb-2">
                          <Input
                            id="season-both"
                            name="season"
                            type="radio"
                            className="form-check-input"
                            checked={validation.values.season === "both"}
                            onChange={() => {
                              validation.setFieldValue("season", "both")
                              setSelectedBazaar({
                                bazaar_id: "both",
                                bazaar_name: "both",
                              })
                            }}
                          />
                          <Label
                            className="form-check-label"
                            htmlFor="season-both"
                          >
                            Both
                          </Label>
                        </div>
                        {validation.touched.season &&
                          validation.errors.season && (
                            <div className="text-danger small">
                              {validation.errors.season}
                            </div>
                          )}
                      </div>

                      <div className="mb-4">
                        <Label className="form-label d-block">
                          {`Are you coming on ${bazaars?.[0]?.booking_date}, ${
                            bazaars?.[0]?.booking_date
                              ? moment(bazaars[0].booking_date).format("dddd")
                              : ""
                          } for booking? `}
                          <span className="text-danger">*</span>
                        </Label>
                        {radioOptions.comingOn.map(option => (
                          <div className="form-check mb-2" key={option}>
                            <Input
                              id={`comingOn-${option}`}
                              name="comingOn"
                              type="radio"
                              className="form-check-input"
                              value={option}
                              checked={validation.values.comingOn === option}
                              onChange={validation.handleChange}
                            />
                            <Label
                              className="form-check-label"
                              htmlFor={`comingOn-${option}`}
                            >
                              {option}
                            </Label>
                          </div>
                        ))}
                        {validation.touched.comingOn &&
                          validation.errors.comingOn && (
                            <div className="text-danger small">
                              {validation.errors.comingOn}
                            </div>
                          )}
                      </div>

                      <div className="mb-4">
                        <Label className="form-label d-block">
                          How many are coming for your booking? Helps us
                          arranging for Breakfast & tea.{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        {radioOptions.attendees.map(option => (
                          <div className="form-check mb-2" key={option}>
                            <Input
                              id={`attendees-${option}`}
                              name="attendees"
                              type="radio"
                              className="form-check-input"
                              value={option}
                              checked={validation.values.attendees === option}
                              onChange={validation.handleChange}
                            />
                            <Label
                              className="form-check-label"
                              htmlFor={`attendees-${option}`}
                            >
                              {option}
                            </Label>
                          </div>
                        ))}
                        {validation.touched.attendees &&
                          validation.errors.attendees && (
                            <div className="text-danger small">
                              {validation.errors.attendees}
                            </div>
                          )}
                      </div>

                        {/* <Card>
                          <CardBody> */}
                          <div className="mb-4">
                            <Label className="form-label" htmlFor="pvsCard">
                              PVS Card <span className="text-danger">*</span>
                            </Label>
                            <Select
                              id="pvsCard"
                              name="pvsCard"
                              options={pvsOptions}
                              classNamePrefix="select"
                              placeholder="Select your PVS Card..."
                              value={validation.values.pvsCard}
                              onChange={val => {
                                validation.setFieldValue("pvsCard", val)
                                setSelectedPvsCard(val)
                              }}
                              onBlur={() =>
                                validation.setFieldTouched("pvsCard", true)
                              }
                            />
                            {validation.touched.pvsCard &&
                              validation.errors.pvsCard && (
                                <div className="text-danger small mt-1">
                                  {validation.errors.pvsCard}
                                </div>
                              )}
                          </div>

                          {/* <h3 className="nom-title">Product Details</h3> */}

                          <div className="mb-3 mt-3">
                            <Label className="form-label" htmlFor="products">
                              Select Product from the dropdown
                            </Label>
                            <Select
                              id="products"
                              name="products"
                              isMulti
                              options={productOptions}
                              classNamePrefix="select"
                              placeholder="Search the product..."
                              value={validation.values.products}
                              onChange={val =>
                                validation.setFieldValue("products", val)
                              }
                              onBlur={() =>
                                validation.setFieldTouched("products", true)
                              }
                            />
                          </div>

                          <div className="mb-4 mt-4">
                            <TagInput
                              tags={validation.values.otherProducts}
                              title="Other Products: If you don't find your product in the list above, please type it here to add it."
                              onChange={list =>
                                validation.setFieldValue("otherProducts", list)
                              }
                            />
                          </div>
                        {/* </CardBody>
                      </Card> */}

                      {/* <Card>
                        <CardBody> */}
                          <h3 className="nom-title">Billing Details</h3>

                          <div className="mb-3 row mt-3">
                            <div className="col-12 col-sm-3">
                              <Label
                                className="form-label"
                                htmlFor="first_name"
                              >
                                Primary Contact{" "}
                                <span className="text-danger">*</span>
                              </Label>
                            </div>
                            <div className="col-12 col-sm">
                              <div className="row">
                                <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                                  <Input
                                    name="firstName"
                                    className="form-control"
                                    placeholder="First Name"
                                    type="text"
                                    id="first_name"
                                    value={validation.values.firstName}
                                    onChange={validation.handleChange}
                                  />
                                  {validation.touched.firstName &&
                                    validation.errors.firstName && (
                                      <div className="text-danger small mt-1">
                                        {validation.errors.firstName}
                                      </div>
                                    )}
                                </div>
                                <div className="col-12 col-sm-6">
                                  <Input
                                    name="lastName"
                                    className="form-control"
                                    placeholder="Last Name"
                                    type="text"
                                    id="last_name"
                                    value={validation.values.lastName}
                                    onChange={validation.handleChange}
                                  />
                                  {validation.touched.lastName &&
                                    validation.errors.lastName && (
                                      <div className="text-danger small mt-1">
                                        {validation.errors.lastName}
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <div className="col-12 col-sm-3">
                              <Label className="form-label" htmlFor="emailr">
                                Contact Info{" "}
                                <span className="text-danger">*</span>
                              </Label>
                            </div>
                            <div className="col-12 col-sm">
                              <div className="row">
                                <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                                  <Input
                                    name="email"
                                    className="form-control"
                                    placeholder="Email ID"
                                    type="email"
                                    id="emailr"
                                    value={validation.values.email}
                                    onChange={validation.handleChange}
                                  />
                                  {validation.touched.email &&
                                    validation.errors.email && (
                                      <div className="text-danger small mt-1">
                                        {validation.errors.email}
                                      </div>
                                    )}
                                </div>
                                <div className="col-12 col-sm-6">
                                  <Input
                                    name="mobileNo"
                                    className="form-control"
                                    placeholder="Mobile Number"
                                    type="number"
                                    id="Mob_number"
                                    value={validation.values.mobileNo}
                                    onChange={validation.handleChange}
                                  />
                                  {validation.touched.mobileNo &&
                                    validation.errors.mobileNo && (
                                      <div className="text-danger small mt-1">
                                        {validation.errors.mobileNo}
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <div className="col-12 col-sm-3">
                              <Label
                                className="form-label"
                                htmlFor="company_name"
                              >
                                Company Info{" "}
                                <span className="text-danger">*</span>
                              </Label>
                            </div>
                            <div className="col-12 col-sm">
                              <div className="row">
                                <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                                  <Input
                                    name="companyName"
                                    className="form-control"
                                    placeholder="Company Name"
                                    type="text"
                                    id="company_name"
                                    value={validation.values.companyName}
                                    onChange={validation.handleChange}
                                  />
                                  {validation.touched.companyName &&
                                    validation.errors.companyName && (
                                      <div className="text-danger small mt-1">
                                        {validation.errors.companyName}
                                      </div>
                                    )}
                                </div>
                                <div className="col-12 col-sm-6">
                                  <Input
                                    name="gstNumber"
                                    className="form-control"
                                    placeholder="GST Number"
                                    type="text"
                                    id="gst_number"
                                    value={validation.values.gstNumber}
                                    onChange={validation.handleChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <div className="col-12 col-sm-3">
                              <Label className="form-label" htmlFor="address">
                                Address <span className="text-danger">*</span>
                              </Label>
                            </div>
                            <div className="col-12 col-sm-9">
                              <textarea
                                name="address"
                                className="form-control"
                                id="address"
                                rows="3"
                                value={validation.values.address}
                                onChange={validation.handleChange}
                              />
                              {validation.touched.address &&
                                validation.errors.address && (
                                  <div className="text-danger small mt-1">
                                    {validation.errors.address}
                                  </div>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <div className="col-12 col-sm-3">
                              <Label className="form-label" htmlFor="state">
                                State & City{" "}
                                <span className="text-danger">*</span>
                              </Label>
                            </div>
                            <div className="col-12 col-sm">
                              <div className="row">
                                <div className="col-12 col-sm-4 mb-3 mb-sm-0">
                                  <Select
                                    name="state"
                                    value={validation.values.state}
                                    onChange={val =>
                                      validation.setFieldValue("state", val)
                                    }
                                    options={stateOptions}
                                    classNamePrefix="select2-selection"
                                    placeholder="State"
                                  />
                                  {validation.touched.state &&
                                    validation.errors.state && (
                                      <div className="text-danger small mt-1">
                                        {validation.errors.state}
                                      </div>
                                    )}
                                </div>
                                <div className="col-12 col-sm-4 mb-3 mb-sm-0">
                                  <Input
                                    name="city"
                                    className="form-control"
                                    placeholder="City"
                                    type="text"
                                    id="city"
                                    value={validation.values.city}
                                    onChange={validation.handleChange}
                                  />
                                  {validation.touched.city &&
                                    validation.errors.city && (
                                      <div className="text-danger small mt-1">
                                        {validation.errors.city}
                                      </div>
                                    )}
                                </div>
                                <div className="col-12 col-sm-4">
                                  <Input
                                    name="pincode"
                                    className="form-control"
                                    placeholder="Pin Code"
                                    type="number"
                                    id="pincode"
                                    value={validation.values.pincode}
                                    onChange={validation.handleChange}
                                  />
                                  {validation.touched.pincode &&
                                    validation.errors.pincode && (
                                      <div className="text-danger small mt-1">
                                        {validation.errors.pincode}
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        {/* </CardBody>
                      </Card> */}

                      <div className="mt-4 mb-3">
                        <Button color="primary" type="submit">
                          Submit
                        </Button>
                      </div>
                    </Form>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <PageLoader open={addBazaarInterestScreen.loading} />
      <ConfirmPopup
        title="Unauthorized"
        isOpen={isConfirmOpen}
        message="You need to be a PVS Member to proceed. Please become a PVS Member to proceed."
        onConfirm={() => {
          navigate("/pvs-info", { replace: true })
        }}
        confirmText="Become a PVS Member"
        cancelText="I'll do it later"
        toggle={() => {
          setIsConfirmOpen(false)
          navigate("/home", { replace: true })
        }}
      />
    </div>
  )
}

export default BazaarInterestForm
